//TODO: MOVE TO ABSTRACT PROJECT INTERFACE
import {Money} from "../../../api-client";

export const calculateCollectedPercentage = (invested: Money, needed: Money) => {
  return parseFloat((invested.amount / needed.amount).toFixed(2)) * 100;
};